// libraries
import React from 'react'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// utils
import { isNonWhitespaceString, limitCharacters } from '/lib/reactutils/utils.js'

export interface OtherLineProps {
	href: string
	name: string
	description: string
}

export default function OtherLine({
   href,
   name,
   description
}: OtherLineProps) {
	return (
		<a
			href={href}
			className='other-line'
		>
			
			<div className='other-line__infos'>

				{isNonWhitespaceString(name) && (
					<p className='other-line__name'>
						{name}
					</p>
				)}

				{isNonWhitespaceString(description) && (
					<div
						className='other-line__description'
						dangerouslySetInnerHTML={{
							__html: limitCharacters(description, 210)
						}}
					/>
				)}

			</div>

			<div className='other-line__icon'>
				<UxArrowRight />
			</div>

		</a>
	)
}